// @flow

import type {
  ActionHandlers,
  Reducer,
} from '@travel-frontend/state-handling-sdk';
import type {DeletePaymentSuccess} from 'redux/v1/paymentInsurance/delete/actions';
import type {DeleteState} from 'redux/v1/paymentInsurance/delete/DeleteState';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';

import {DELETE_PAYMENT} from 'redux/v1/paymentInsurance/delete/actions';

export const initialState: DeleteState = {
  loading: false,
};

const actionCreators: ActionHandlers<DeleteState> = {
  [PENDING(DELETE_PAYMENT)]: (
    state: DeleteState,
    action: DeletePaymentSuccess
  ) => ({
    ...state,
    loading: true,
  }),
  [SUCCESS(DELETE_PAYMENT)]: (
    state: DeleteState,
    action: DeletePaymentSuccess
  ) => ({
    ...state,
    loading: false,
    success: true,
  }),
  [ERROR(DELETE_PAYMENT)]: (state: DeleteState, action: any) => ({
    ...state,
    success: false,
    loading: false,
    error: action.error,
  }),
};

export const deleteReducer: Reducer<DeleteState> =
  // $FlowFixMe
  createReducerUsingActionHandlers<DeleteState>(initialState, actionCreators);
